export default {
  MAX_CHARACTERS_FOLDER_NAME: 50,
  MAX_FOLDER_DEPTH: 5,
  DEFAULT_FOLDER_COLOR_ID: 'DEFAULT',
};
